module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cpKSg"))).then(() => module.bundle.root('ewmtE'));